/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remind_Me_LaterInputs */



/**
* | output |
* | --- |
* | "Remind Me Later" |
*
* @param {Remind_Me_LaterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remind_me_later = /** @type {((inputs?: Remind_Me_LaterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remind_Me_LaterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Me le rappeler plus tard")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erinnere mich später")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ricordamelo più tardi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Напомни мне позже")
	if (locale === "es") return /** @type {LocalizedString} */ ("Recuérdamelo más tarde")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("稍后提醒我")
	if (locale === "ja") return /** @type {LocalizedString} */ ("後で通知する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मुझे बाद में याद दिलाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Lembre-me mais tarde")
	return /** @type {LocalizedString} */ ("Remind Me Later")
});